import React from "react";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { FastField, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { CampoPassword, CELULAR_AYUDA, celularSchema, ErrorMessage, history, LoadingBoton } from "../../_helpers";
import { userService } from "../../_services";
import userServiceTs from "../../_services/cart/userService";
import alertService from "../../_services/cart/alert.service";
import { GoogleAuthButton } from "./GoogleAuthButton";

class RegisterPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      token: undefined,
      codigoEnviado: false
    };
  }

  state = {
    codigo:undefined,
    grabando: false,
    verPass: false,
  };

  cargarGtoken(token) {
    this.setState({ token: token });
  }

  mailExiste = (value) => {
    if (!!value && value.length > 7) {
      let valor = false;
      valor = userService.chequearMailExiste(value).then(
        (data) => {
          return data.existe;
        },
        (error) => {
          console.error(error);
        }
      );
      return valor;
    } else {
      return false;
    }
  };

  errorGtoken(error) {
    console.log("ERROR GTOKEN:", error);
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  validarCodigo = () =>{
    userServiceTs.chequerCodigo(this.state.values, this.state.codigo, this.onCodigoCorrecto)
  }

  onCodigoCorrecto = (correcto) =>{
    if(correcto){
      alertService.msg('Usuario registrado, ahora sera logueado automaticamente');
      // El alta de vendedores sigue en los planes: ya arranca con la prueba gratis y ahi elige.
      this.props.registrar(this.state.values, this.setGrabando, this.props.vendedor ? '/planes' : undefined);
    }else{
      alertService.error('El codigo ingresado no es correcto');
    }
  }

  onCodigoSent = (values) =>{
    // `vendedor` viene de la ruta /registro-vendedor (el link de alta para vendedores).
    this.setState({codigoEnviado: true, values: {...values, esVendedor: !!this.props.vendedor}});
  }

  setGrabando = (grabando) => {
    this.setState({ grabando: grabando });
  };

  render() {
    const { grabando } = this.state;

    const passwoordRegExp = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;

    const thisAdentro = this;
    const validationSchema = Yup.object().shape({
		terminos: Yup.bool().oneOf([true], 'Debe aceptar los terminos y condiciones').required('Debe aceptar los terminos y condiciones'),
      email: Yup.string()
        .min(2, "Muy corto")
        .max(100, "No puede exceder los 100 caracteres")
        .email("Mail incorrecto")
        // .test("checkDuplUsername", "Mail existente", function (value) {
        //   return thisAdentro.mailExiste(value);
        // })
        .required("Requerido"),
      password: Yup.string()
        .min(8, "El password debe contener al menos 8 caracteres")
        .matches(
          passwoordRegExp,
          "Al menos 8 caracteres, una letra y un número!"
        )
        .max(50, "Demasiado largo")
        .required("Requerido"),
      confpassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Las contraseñas no coinciden")
        .required("Requerido"),
      // Obligatorio: es el único canal por el que la otra parte de una operación te encuentra
      // fuera del sitio. La misma regla corre en el backend (CelularUtils), no sólo acá.
      numeroCelular: celularSchema,
    });

    let inic = {
		terminos: false,
		numeroCelular: ""
	};

    return (
      <div className="container__dap">
        <div className="login">
          <div className="login__container">
            <div className="login__header">
              {this.props.vendedor ? (
                <>
                  <h2 className="">
                    Vendé en <span> DEAUTOPARTES</span>
                  </h2>
                  <span className="small">
                    Creá tu cuenta de vendedor y usá todo gratis durante la prueba.
                    Después elegís el plan que te sirva.
                  </span>
                </>
              ) : (
                <>
                  <h2 className="">
                    Unite a la comunidad <span> DEAUTOPARTES</span>
                  </h2>
                  <span className="small">
                    Es un sitio donde vendedores y compradores de autopartes pueden
                    encontrar lo que buscan
                  </span>
                </>
              )}
            </div>

            {this.state.codigoEnviado &&

              <div className="login__body">
                    <div className={"form-group"}>
                      <label htmlFor="username">Codigo</label>
                      <div className="input-group">
                      <input
                          type="text"
                          className="form-control"
                          name="codigo"
                          value={this.state.codigo}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>

                    <div className="login-btn">
                        <button
                          disabled={this.state.grabando || this.state.codigo === undefined ||  this.state.codigo.length < 4} onClick={()=>this.validarCodigo()} className="button" type="button" data-type='primary'
                        >
                          Validar codigo y crear cuenta
                          <LoadingBoton grabando={this.state.grabando} />
                        </button>
                      </div>
              </div>
            }

            {!this.state.codigoEnviado && <div className="login__body">
              <Formik
                enableReinitialize={true}
                validationSchema={validationSchema}
                initialValues={inic}
                onSubmit={(values) => {

                  userServiceTs.enviarCodigoMail(values, this.onCodigoSent);
                }}
              >
                {({ errors, touched, values, setFieldValue, submitForm }) => (
                  <>
                    <Form>
                      <div className={"form-group"}>
                        <label htmlFor="username">Email</label>
                        <div className="input-group">
                          <FastField name="email" />
                          <ErrorMessage name={`email`} />
                        </div>
                      </div>
                      <div className={"form-group"}>
                        <label htmlFor="numeroCelular">Celular</label>
                        <div className="input-group">
                          <FastField name="numeroCelular" type="tel" inputMode="tel"
                                     placeholder="1155667788" />
                          <ErrorMessage name={`numeroCelular`} />
                          <small className="form-hint">{CELULAR_AYUDA}</small>
                        </div>
                      </div>
                      <div>
                      <div className={"form-group"}>
                        <label htmlFor="password">Contraseña</label>
                        <CampoPassword
                          mostrar={this.state.verPass}
                          onToggle={() =>
                            this.setState({ verPass: !this.state.verPass })
                          }
                        >
                          <Field
                            type={this.state.verPass ? "text" : "password"}
                            name="password"
                          />
                        </CampoPassword>
                        {/* Afuera del campo: adentro empujaba al ojo y le corria el centro. */}
                        <ErrorMessage name={`password`} />
                      </div>
                      </div>
                      <div className={"form-group"}>
                        <label htmlFor="password">Confirmar Contraseña</label>
                        {/* Tambien con ojo: comparte el `verPass` del campo de arriba, y con
                            uno solo de los dos campos con ojo quedaba a la vista el desparejo. */}
                        <CampoPassword
                          mostrar={this.state.verPass}
                          onToggle={() =>
                            this.setState({ verPass: !this.state.verPass })
                          }
                        >
                          <Field
                            type={this.state.verPass ? "text" : "password"}
                            name="confpassword"
                          />
                        </CampoPassword>
                        <ErrorMessage name={`confpassword`} />
                      </div>

					            <div className={"form-group--checkbox"}>
                        <div className="checkbox-container">
                          <Field type='checkbox' name="terminos"/>
                          <label htmlFor="terminos">Al registrarme acepto <a href="/terminos-condiciones" target="_blank">Terminos y condiciones</a> para el uso de este sitio</label>
                        </div>
                          <ErrorMessage name={`terminos`} />
                      </div>

                      <div className="login-btn">
                        <button
                          disabled={this.state.grabando}
                          className="button"
                          type="submit"
                          data-type='primary'
                        >
                          Registrar
                          <LoadingBoton grabando={this.state.grabando} />
                        </button>
                      </div>
                    </Form>
                  </>
                )}
              </Formik>
            </div>}
            {/* El alta con Google crea un comprador: en el link de vendedores no se ofrece. */}
            {!this.props.vendedor && (
            <div className="login__socialButtons">
          <span className="other__buttons">O</span>

          <GoogleAuthButton login={this.props.login} onSuccess={this.props.onSuccess} />
        </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapState(state) {
  return {};
}

const actionCreators = {
  login: userActions.login,
  registrar: userActions.registrar
};

const connectedRegisterPage = connect(mapState, actionCreators)(RegisterPage);
export { connectedRegisterPage as RegisterPage };
